import { ACCRUAL_PERIOD_DATE } from "@/constants/accrualPeriods";

export function AccrualPeriod(data) {
    const period = data.period || ACCRUAL_PERIOD_DATE;
    const periodValue = data[period] || [];

    return {
        period,
        [period]: periodValue,
    };
}

export function formatAccrualPeriod(data) {
    const { period } = data;

    return {
        period,
        [period]: data[period],
    };
}
